import { ListAccountsReq } from "gen/api/accounting/service_pb"
import { Account } from "gen/coa/models_pb"
import { UUID } from "shared-ts/classes/uuid"
import {
  Combobox,
  ComboboxProps,
} from "shared-web/components/base/input/Combobox"

import { useListAccountsQuery } from "features/api/accounting"
import { sortedAccounts } from "lib/accounting/accounting"
import { AccountNumberChip } from "lib/accounting/AccountNumberChip"

interface AccountComboboxProps
  extends Omit<
    ComboboxProps<Account>,
    "items" | "keyExtractor" | "valueExtractor" | "filterValueExtractor"
  > {
  req?: ListAccountsReq
}

export function AccountCombobox(props: AccountComboboxProps) {
  const { req, ...comboboxProps } = props
  const { data: listAccountsData } = useListAccountsQuery(
    ListAccountsReq.create(
      req ?? {
        accountTypes: [],
        filterActive: true,
      }
    )
  )

  return (
    <Combobox<Account | null>
      items={sortedAccounts(listAccountsData?.accounts ?? [])}
      keyExtractor={(a) =>
        a?.id ? UUID.fromPB(a.id).toString() : a?.number?.toString() ?? ""
      }
      renderItemPrefix={(a) => (a ? <AccountNumberChip account={a} /> : <></>)}
      valueExtractor={(a) => a?.name ?? ""}
      filterValueExtractor={(a) => (a ? `${a.number} ${a.name}` : "")}
      {...comboboxProps}
    />
  )
}
